export default "__VITE_ASSET__9667b8c5__"